/**
 * A declaration an object makes on its own `userData` under one key, for a reader elsewhere in the
 * scene. One key, so an object carries one declaration of each kind.
 */
/** `hasShape` checks the fields of a candidate that is already a non-null object. */
export function userDataDeclaration(key, hasShape) {
    return {
        userData: (declaration) => ({ [key]: declaration }),
        read: (object) => {
            const value = object.userData[key];
            if (typeof value !== 'object' || value === null)
                return null;
            return hasShape(value) ? value : null;
        },
    };
}
//# sourceMappingURL=userDataDeclaration.js.map